import { AuthServiceConfig } from '@vis-auth/vis-auth';
import {
  getLoginDotGovClientId,
  Scope,
  sessionTimers,
  requestPathPrefix,
  getAuthLifecylceHooks,
} from './auth-config-helpers';

export const getLoginDotGovAuthConfiguration = (): AuthServiceConfig => {
  return {
    issuer: '/api/identity/v1',
    clientId: getLoginDotGovClientId(),
    redirectUri: `${window.location.origin}/save/app/client/ui/home/loginDotGov`,
    tokenStorage: 'local',
    errorPath: '/save/app/client/ui/error',
    scope: Scope.LoginDotGov,
    session: sessionTimers,
    refreshUri: `${window.location.origin}${requestPathPrefix}/refresh_session`,
    hooks: getAuthLifecylceHooks(),
  };
};
